export default __webpack_public_path__ + "static/media/330_private01-es-web.35b6a9e9.png";